@if (props.readonly) {
  <new-ui-candidate-document-date
    [maskTabKey]="null"
    [maskFieldName]="null"
    [candidateForm]="field.form"
    [candidateId]="props.candidateId"
    [candidateOrganizationId]="props.organizationId"
    [disabled]="props.disabled"
    [readonly]="true"
    [label]="props.label"
    [documentType]="props.documentType"
    [selectedSet]="props.selectedSet"
    [dateField]="props.dateField"
    [showDocumentCompletion]="props.showDocumentCompletion"
    [dt]="props.dt"
  />
} @else {
  <div class="col">
    <p-overlaybadge [dt]="props?.dt?.components?.overlaybadge" [badgeDisabled]="formControl.pristine" severity="info">
      <new-ui-candidate-document-date
        [maskTabKey]="null"
        [maskFieldName]="null"
        [candidateForm]="field.form"
        [candidateId]="props.candidateId"
        [candidateOrganizationId]="props.organizationId"
        [disabled]="props.disabled"
        [label]="props.label"
        [documentType]="props.documentType"
        [selectedSet]="props.selectedSet"
        [dateField]="props.dateField"
        [showDocumentCompletion]="props.showDocumentCompletion"
      />
    </p-overlaybadge>

    @if (!props.readonly && props.hint) {
      <p-message [dt]="props.dt?.components?.message" severity="info" variant="simple" size="small">
        {{ props.hint }}
      </p-message>
    }

    @if (showError) {
      <p-message [dt]="props.dt?.components?.message" severity="error" variant="simple" size="small">
        <formly-validation-message [field]="field" />
      </p-message>
    }
  </div>
}
